module.exports = __webpack_public_path__ + "static/media/img_propose_b_02.2c432e56.png";